// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dZC0Qb1FVInAKj {
  display: flex;
  align-items: center;
  margin: var(--ds-space-0, 0);
  padding: var(--ds-space-200, 16px);
  border-radius: 8px;
  background-color: var(--ds-surface-sunken, #f7f8f9);
  text-align: left;
  cursor: pointer;
}
.dZC0Qb1FVInAKj .DEiVC8K9xirj7E {
  display: flex;
  flex: 1;
}
.dZC0Qb1FVInAKj:hover {
  background-color: var(--ds-background-neutral-subtle-hovered, #091e420f);
}
.dZC0Qb1FVInAKj.DzkJmRWBioFw8K {
  background-color: var(--ds-background-selected, #e9f2ff);
  box-shadow: inset 0 0 0 2px var(--ds-border-selected, #0c66e4);
}
.dZC0Qb1FVInAKj .DjI3hGdD1KlXi_ {
  padding-right: var(--ds-space-150, 12px);
}
.dZC0Qb1FVInAKj .TOC8lWQYnBVI7F {
  flex: 1;
}
.dZC0Qb1FVInAKj .Gngw4SG578OD8_ {
  font-size: 14px;
  font-weight: var(--ds-font-weight-bold, bold);
  line-height: 20px;
  text-overflow: ellipsis;
}
.dZC0Qb1FVInAKj .wGmqtZDwuyrHm4 {
  height: 14px;
  color: var(--ds-text-subtle, #44546f);
  font-size: 11px;
  line-height: 14px;
}
.dZC0Qb1FVInAKj + .dZC0Qb1FVInAKj {
  margin-top: var(--ds-space-100, 8px);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"listItemContainer": `dZC0Qb1FVInAKj`,
	"listItem": `DEiVC8K9xirj7E`,
	"selected": `DzkJmRWBioFw8K`,
	"avatar": `DjI3hGdD1KlXi_`,
	"text": `TOC8lWQYnBVI7F`,
	"name": `Gngw4SG578OD8_`,
	"info": `wGmqtZDwuyrHm4`
};
export default ___CSS_LOADER_EXPORT___;
